import type { QueryClient } from "@tanstack/react-query"
import { showNotification } from "@/entities/notification"
import { userKeys } from "@/entities/user"
import * as m from "@/paraglide/messages"
import {
	type NotificationHandlerContext,
	registerNotification,
} from "@/shared/api/websocket"
import { upsertFriendInCache } from "../lib/update-friend-cache"
import { friendKeys } from "../model/keys"
import type { Friend } from "../model/types"

function handleFriendFound(
	friend: Friend,
	source: "luni-search" | "invitation",
	userRelationshipId: number,
	userId: number,
	queryClient: QueryClient,
	notificationId: number,
) {
	upsertFriendInCache(queryClient, userId, friend)
	queryClient.invalidateQueries({
		queryKey: friendKeys.list(userId),
		refetchType: "none",
	})
	queryClient.invalidateQueries({ queryKey: userKeys.byId(userId) })
	showNotification({
		type: "friend-found",
		placement: "home",
		friend,
		source,
		userRelationshipId,
		origin: "server",
		notificationId,
	})
}

function invalidateFriends(
	_: unknown,
	{ queryClient, userId }: NotificationHandlerContext,
) {
	queryClient.invalidateQueries({ queryKey: friendKeys.list(userId) })
}

registerNotification("friend_queued", {
	handle: ({ notification_id }) => {
		showNotification({
			type: "friend-not-found",
			placement: "home",
			children: m.wsNoFriendsTitle(),
			buttonText: m.wsNoFriendsBtnOk(),
			origin: "server",
			notificationId: notification_id,
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
registerNotification("friend_found", {
	handle: ({ notification_id, data }, { queryClient, userId }) =>
		handleFriendFound(
			data.friend,
			"luni-search",
			data.user_relationship_id,
			userId,
			queryClient,
			notification_id,
		),
	route: () => ({ to: "/home" }),
	routePopup: null,
})
registerNotification("friend_added", {
	handle: ({ notification_id, data }, { queryClient, userId }) =>
		handleFriendFound(
			data.friend,
			"invitation",
			data.user_relationship_id,
			userId,
			queryClient,
			notification_id,
		),
	route: () => ({ to: "/home" }),
	routePopup: null,
})
registerNotification("friend_confirmed", {
	handle: invalidateFriends,
	route: () => ({ to: "/home" }),
	routePopup: null,
})
registerNotification("friend_blocked", {
	handle: invalidateFriends,
	route: () => ({ to: "/home" }),
	routePopup: null,
})
registerNotification("friend_blocked_by", {
	handle: invalidateFriends,
	route: () => ({ to: "/home" }),
	routePopup: null,
})

registerNotification("search_blocked_pending", {
	handle: ({ notification_id }) => {
		showNotification({
			type: "search-blocked-pending",
			placement: "home",
			origin: "server",
			notificationId: notification_id,
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})

registerNotification("search_blocked_no_message", {
	handle: ({ notification_id, data }) => {
		showNotification({
			type: "search-blocked-no-message",
			placement: "home",
			friend: data.friend,
			origin: "server",
			notificationId: notification_id,
		})
	},
	route: () => ({ to: "/home" }),
	routePopup: null,
})
